import { render, staticRenderFns } from "./updateRecordDetail.vue?vue&type=template&id=31808131&scoped=true&"
import script from "./updateRecordDetail.vue?vue&type=script&lang=js&"
export * from "./updateRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./updateRecordDetail.vue?vue&type=style&index=0&id=31808131&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31808131",
  null
  
)

export default component.exports